



















import { Component, Mixins, Prop } from "vue-property-decorator";
import { PrintBehavior } from "../../../../domain/document/items";
import { ModelEditableMixin } from "../../../system/mixins";

@Component({
})
export default class PrintBehaviorEditor extends Mixins(ModelEditableMixin) {
  @Prop({default: () => ({
    shouldPrint: {
      isEnable: true,
    },
    shouldPreview: {
      isEnable: true,
    },
  })})
  option: {
    shouldPrint: {
      isEnable: boolean;
    },
    shouldPreview: {
      isEnable: boolean;
    },
  };

  // ModelEditableMixinと同時に使う事.ModelEditableMixin利用APIの宣言.
  writePropertyWhenValid: (writer: (source: PrintBehavior) => void) => void;
  readPropertyOrDefault: <T>(reader: (source: PrintBehavior) => T, defaultValue: T) => T;

  get shouldPrint(): boolean {
    return this.readPropertyOrDefault(s => s.shouldPrint, undefined);
  }

  set shouldPrint(value: boolean) {
    this.writePropertyWhenValid(s => {
      s.shouldPrint = value;
      if (value) {
         s.shouldPreview = true;
      }
    });
  }

  get shouldPreview(): boolean {
    return this.readPropertyOrDefault(s => s.shouldPreview, undefined);
  }

  set shouldPreview(value: boolean) {
    this.writePropertyWhenValid(s => {
      s.shouldPreview = value;
      if (!value) {
         s.shouldPrint = false;
      }
    });
  }
}
